import { MapConfig, MapData } from "./types";

const baseUrl = "https://mmm-maps-api.arctouch.com/api";

type UrlPaths = {
  [key in MapConfig]: string;
};

const urlPath: UrlPaths = {
  airQuality: "air",
  pollen: "pollen",
  liveWeather: "weather",
  water: "water",
};

const keyToUrl = (key: MapConfig) => {
  return `${baseUrl}/${urlPath[key]}`;
};

export const mapRequest = async (map: MapConfig): Promise<MapData> => {
  try {
    const response = await fetch(keyToUrl(map));
    if (response.status === 200) {
      const data = await response.json();
      return { [map]: data };
    }
    return Promise.reject(response.status);
  } catch (e) {
    return Promise.reject(e);
  }
};
